export default "__VITE_ASSET__c6AdjkX0__"